import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import account from './modules/account'
import members from './modules/members'

import contacts from './modules/contacts'
import purchases from './modules/purchases'
import events from './modules/events'
import activies from './modules/activities'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VuexPersist from 'vuex-persist';

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
  // .. see> https://alligator.io/vuejs/vuex-persist-state/
})



Vue.use(Vuex);

Vue.use(VueAxios, axios)


const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    user,
    auth,
    account,
    members,

    contacts, // new
    purchases,
    events,
    activies
  },
  strict: debug,
  plugins: [vuexLocalStorage.plugin]
})
